import { GET_CORRECTION_ORDER } from "../constants";
import { ApiCall } from "../../utils";
import { downloadExcel } from "../../utils";
import axios from "axios";

export const getCorrectionOrderList =
  (request, page, debouncedHandleSearch, sortOrder, sortField, rowsPerPage) =>
  async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const searchParam = debouncedHandleSearch
        ? `search=${debouncedHandleSearch}`
        : "";

      const result = await ApiCall.get(
        `/correction_order?${searchParam}&sort_field=${sortField}&sort_order=${sortOrder}&page=${page}&page_size=${rowsPerPage}`,
        token
      );

      dispatch({ type: GET_CORRECTION_ORDER, payload: result.data });
      request.onSuccess();
    } catch (error) {
      request.onError(error);
    }
  };

export const addCorrectionOrderData =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.post(
        "/correction_order",
        request.payload,
        token
      );
      request.onSuccess();
    } catch (error) {
      request.onError(error);
    }
  };

export const deleteCorrectionOrderData =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.delete(
        `/correction_order/${request.correction_order_id}`,
        token
      );
      request.onSuccess();
    } catch (error) {
      request.onError(error);
    }
  };

export const downloadCorrectionTemplate = () => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await axios.get(
      `${process.env.REACT_APP_API_URL}/correction_order/download/csv_template`,
      {
        authorization: `Bearer ${token}`,
        responseType: "blob", // Important: ensures the response is treated as a binary file
      }
    );
    downloadExcel(result, "Correction Order Template");
  } catch (error) {
    console.log("error =>", error);
  }
};

export const addBulkCorrectionOrder =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.post(
        "/correction_order/process/csv_upload",
        request.payload,
        token
      );
      request.onSuccess();
    } catch (error) {
      request.onError();
    }
  };
